<template>
  <div class="container">
    <!-- <div class="header">折抵繳費 - {{ parkingInfo.title }}</div> -->
    <div class="header">{{getTitle() }}</div>
    <div class="info-container">

      <div class="info1">
        <div class="amount-info">
          <div class="label">待繳金額</div>
          <div class="amount">{{ formatParkingFee }}</div>
        </div>
        <div class="details">
          <div class="detail-car">
            <div class="detail-label">登記車號</div>
            <div class="detail-value">{{ carNumber }}</div>
          </div>
          <div class="detail-car">
            <div class="detail-label">停車場 / 停車時間</div>
            <div class="detail-value">{{parkingInfo.title}} / {{parkingInfo.startTime}}</div>
          </div>
        </div>
      </div>

      <div class="payment-options">
        <button class="credit-button" 
        :disabled="discount < -100000000 || !supportsCardDiscount"
        @click="cardDiscount()">信用卡優惠折抵</button>
        <button v-if="false" class="deposit-button" @click="depositDiscount()">儲值金折抵</button>
        <button class="pay-button" @click="onlinePayment()">線上繳費 (商家折抵)</button>
      </div>
    </div>
    <div v-if="true" class="footer-link">
      <a href="#/OnlinePayment" @click="cancel()">查詢其他車號</a>
    </div>
  </div>
</template>

<script>
export default {

  //add parkingFee as property
  props: {
    parkingFee: {
      type: Number,
      required: true
    },
    discount: {
      type: Number,
      required: true
    },
    carNumber: {
      type: String,
      required: true
    },
    parkingInfo: {
      type: Object,
      required: true
    },
    unpaidFee: {
      type: Number,
      required: true
    },
    supportsCardDiscount: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    formatParkingFee() {
      if (this.parkingFee === 0) {
        return '0(已繳費)';
      }
      // return `$${this.parkingFee}`;
      // return `$${this.parkingFee - this.discount}`;
      return `$${this.unpaidFee}`;
    }
  },
  methods: {
    cardDiscount() {
      this.$emit('go-card-discount');
    },
    depositDiscount() {
      this.$emit('go-deposit-discount');
    },
    onlinePayment() {
      this.$emit('go-online-payment');
    },
    cancel() {
      this.$emit('cancel-payment');
    },
    getTitle() {
      if (this.parkingInfo.title ) {
      return `停車費用查詢繳費 - ${this.parkingInfo.title}`;  
      } else {
        return '停車費用查詢繳費';
      }
    }
  }
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 1140px;
  /* height: 348px; */
  /* border: 1px solid #d3d3d3; */
  /* padding: 20px; */
  margin-top: 88px;

  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
}

.header {
  margin: 0px;
  text-align: center;

  font-size: 64px;
  font-weight: 700;

  margin-top: 80px;
  margin-bottom: 30px;
  color: var(--green04);
}


.info-container {

  display: flex;
  flex-direction: row;

  width: 60%;
  min-width: 560px;
  background-color: white;
  padding: 58px;
  border-radius: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;

  justify-content: space-between;
}

.info1 {
  margin-top: 10px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  text-align: left;

  color: var(--gray11);

}


.amount {
  font-weight: bold;
  color: #FF4500;

  font-family: Inter;
  font-size: 48px;
  font-weight: 700;
  line-height: 64.32px;
  text-align: left;


  margin-top: 6px;
}

.details {
  /* margin-top: 32px; */
  margin-top: 20px;

  display: flex;
  flex-direction: row;
  gap: 75px;
}

.detail-car {
  display: flex;
  flex-direction: column;
  margin-top: 4%;


}

.detail-label {
  font-size: 16px;
  font-weight: 700;
  color: var(--gray11);

  text-align: left;
}

.detail-value {
  font-size: 20px;
  color: var(--gray15);
}

.payment-options {
  display: flex;
  flex-direction: column;
  gap: 20px;
}


.credit-button,
.deposit-button,
.pay-button {

  width: 230px;
  height: 58px;
  min-height: 48px;
  top: 58px;
  left: 1144px;
  padding: 16px 32px 16px 32px;
  gap: 10px;
  border-radius: 99px;
 
  white-space: nowrap;


  font-size: 18px;
  font-weight: 700;
  text-align: center;
}

.credit-button {
  background-color: var(--green03);
  color: white;

  border: none;
}

.credit-button:disabled {
  /* background-color: var(--gray06); */
  opacity: 0.5;
  /* color: var(--gray11); */
}

.deposit-button {
  background-color: var(--green01);
  color: white;

  border: none;
}

.pay-button {
  background-color: white;
  color: var(--green03);
  border: 2px solid var(--green03);
}

.footer-link {
  margin-top: 24px;

  font-weight: 700px;

}

.footer-link a {
  color: var(--green03);
  text-decoration: none;
  font-size: 16px;
  line-height: 24px;

  /*add underline*/
  border-bottom: 1px solid var(--green03);

  color: var(--green03);
}

@media (max-width: 560px) {

  .container {
    width: 100%;
    height:auto;
    /* height: 1140px; */
    /* height: 348px; */
    /* border: 1px solid #d3d3d3; */
    /* padding: 20px; */
    margin-top: 56px;


   }

  .header {
    margin-top: 40px;
    margin-bottom: 20px;
    font-size: 32px;
    line-height: 43.52px;
  }


  .info-container {
    width: 343px;
    height: 510px;
    border-radius: 20px;
    padding: 20px;
    min-width: unset; /* Override min-width */
    /* width: 100%; Ensure it fits smaller screens */
    box-sizing: border-box;

    flex-direction: column;
  }

  .info1 {
    margin-top: 0px;


    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;

    color: var(--gray11);

  }


  .amount {

    font-size: 40px;
    line-height: 53.6px;


    margin-top: 6px;
  }

  .details {
    /* margin-top: 32px; */
    margin-top: 20px;

    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .detail-car {
    display: flex;
    flex-direction: column;
    margin-top: 8px;


  }

  .detail-label {
    font-size: 14px;
    line-height: 21.56px;
    font-weight: 700;
    color: var(--gray11);

    text-align: left;
  }

  .detail-value {
    font-size: 16px;
    line-height: 24px;
    color: var(--gray15);
  }

  .payment-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }


  .credit-button,
  .deposit-button,
  .pay-button {

    width: 100%;
    /* min-height: 48px; */
    padding: 10px 20px 10px 20px;
    gap: 4px;
    border-radius: 99px;



    font-size: 14px;
    font-weight: 700;
    line-height: 21.56px;
    text-align: center;
  }

  .credit-button {
    background-color: var(--green03);
    color: white;

    border: none;
  }

  .deposit-button {
    background-color: var(--green01);
    color: white;

    border: none;
  }

  .pay-button {
    background-color: white;
    color: var(--green03);
    border: 2px solid var(--green03);
  }

  .footer-link {
    margin-top: 24px;

    font-weight: 700px;

    margin-bottom: 24px;

  }

  .footer-link a {
    color: var(--green03);
    text-decoration: none;
    font-size: 14px;
    line-height: 24px;

    /*add underline*/
    border-bottom: 1px solid var(--green03);

    color: var(--green03);
  }


}
</style>
